export const SETCOMPLAINTSLIST = "SETCOMPLAINTSLIST";
export const SETBPMASTERLIST = "SETBPMASTERLIST";
export const SETBPMASTERBYID = "SETBPMASTERBYID";
export const SETCUSTOMERGROUP = "SETCUSTOMERGROUP";
export const SETCURRENCY = "SETCURRENCY";
export const SETSERIES = "SETSERIES";
